// extracted by mini-css-extract-plugin
export default {"container":"aca-z","productName":"bca-z","price":"cca-z","dimensions":"dca-z"};